import { TFunction } from "i18next";
import { ReviewCreationForm } from "../domain/models/dto/ReviewDTO";
import { Fields } from "../types/SchemaFactory";
import { schemaFactory } from "./SchemaFactory";

export const reviewCreationFields: Fields<ReviewCreationForm> = {
    comment: {
        min: 2,
        max: 500,
        required: false,
        placeholderKey: "reviews.commentPlaceholder",
        type: "text",
        initial: "",
    },
    rate: {
        min: { value: 1, key: "reviews.rateRequired" },
        max: { value: 5, key: "reviews.rateRequired" },
        required: { value: true, key: "reviews.rateRequired" },
        placeholderKey: "",
        type: "number",
        initial: 0,
    },
};

export const reviewCreationSchemaFactory = (t: TFunction) => {
    return schemaFactory(t, reviewCreationFields);
};
